import { useInfiniteQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { InfiniteQueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';
import { Filter } from '@/src/util/filters';

import { sanitizeFilter } from './getFiles';

import { LibraryItemDTO } from '../types';

const url = `${PREFIX_URL}/projects/:projectId/library/trash`;

export type GetTrashResponse = {
  status: boolean;
  data: (LibraryItemDTO & {
    documentId: string | null;
    'uploaded-by': string | null;
    'uploaded-date': string | null;
  })[];
};
export const getTrashQueryKey = {
  list: ['getTrash'] as const,
};

const LIST_LIMIT = 20;

export type GetTrashParams = {
  page: number;
  projectId: number;
  filter: Filter[];
};

export const getTrash = ({
  projectId,
  page,
  filter,
}: GetTrashParams): Promise<GetTrashResponse> => {
  const URL = generateRoutePath(url, { projectId });
  const sanitized = filter ? sanitizeFilter(filter) : [];
  const filterParams =
    Array.isArray(sanitized) && sanitized.length > 0 ? { filter: JSON.stringify(sanitized) } : {};

  const params = {
    page,
    limit: LIST_LIMIT,
    ...filterParams,
  };

  return axios.get(URL, { params });
};
type QueryFnType = typeof getTrash;

type UseGetTrashOptions = {
  projectId: number;
  filter: Filter[];
  config?: InfiniteQueryConfig<QueryFnType>;
};

export const useGetTrash = ({ projectId, filter, config }: UseGetTrashOptions) => {
  return useInfiniteQuery({
    queryKey: [...getTrashQueryKey.list, projectId, filter],
    queryFn: ({ pageParam = 1 }) => getTrash({ projectId, page: pageParam, filter }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.data.length === LIST_LIMIT ? allPages.length + 1 : undefined;
    },
    cacheTime: 5000,
    staleTime: 5000,
    // cacheTime: 0,
    // staleTime: Infinity,
    ...config,
  });
};
